import { Component, TemplateRef, ContentChild, ViewContainerRef, Input } from '@angular/core';
var Item = /** @class */ (function () {
    function Item() {
    }
    Item.decorators = [
        { type: Component, args: [{
                    selector: 'c-item',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    Item.ctorParameters = function () { return []; };
    Item.propDecorators = {
        'template': [{ type: ContentChild, args: [TemplateRef,] },],
    };
    return Item;
}());
export { Item };
var TemplateRenderer = /** @class */ (function () {
    function TemplateRenderer(viewContainer) {
        this.viewContainer = viewContainer;
    }
    TemplateRenderer.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.data.template, {
            '\$implicit': this.data,
            'item': this.item
        });
    };
    TemplateRenderer.prototype.ngOnDestroy = function () {
        this.view.destroy();
    };
    TemplateRenderer.decorators = [
        { type: Component, args: [{
                    selector: 'c-templateRenderer',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    TemplateRenderer.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    TemplateRenderer.propDecorators = {
        'data': [{ type: Input },],
        'item': [{ type: Input },],
    };
    return TemplateRenderer;
}());
export { TemplateRenderer };
//# sourceMappingURL=menu-item.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/menu-item.js
// module id = 179
// module chunks = 9